import React from 'react';
const catTypeColors = { 'mandatory': '#21ba45', 'addon': '#fbbd08' };

const SubcategoriesLinks = ({ subcategories, onSubcategoryClick }) => {
    return subcategories.map((cat, index) => (
        <span key={index}>
            <a style={{ cursor: 'pointer' }} onClick={() => onSubcategoryClick(cat.id)}>
                <span style={{ color: catTypeColors[cat.type] }}><b>{`[${cat.key}]`}</b> {cat.name}</span>
            </a>
            {subcategories.length === index + 1 ? '' : ' | '}
        </span>
    ));
};

export default SubcategoriesLinks;